import ReactDOM from "react-dom";

import { BrowserRouter, Route } from "react-router-dom";
import { ToolboxSearch } from "./ToolboxSearch";
import { i18nService } from "services";
import {
  QueryParamProvider,
  transformSearchStringJsonSafe,
} from "use-query-params";

(() => {
  const toolboxSearchContainers = document.querySelectorAll<HTMLElement>(
    "[data-toolbox-search]"
  );

  if (!toolboxSearchContainers) return;

  toolboxSearchContainers.forEach((toolboxSearchContainer) => {
    const data = toolboxSearchContainer.dataset.toolboxSearch;
    const parentToolId =
      toolboxSearchContainer.dataset.toolboxSearchParentToolId;

    if (!data) return;

    let toolboxSearchData = JSON.parse(data);

    if (!toolboxSearchData) return;

    toolboxSearchData = {
      subToolTypeOptions: [
        {
          label: i18nService.copy["toolQuickSearch.choose"]?.replace(
            "@filter",
            "type"
          ),
          value: "",
          type: "",
          name: "",
        },
        ...toolboxSearchData[0].options.map((option: any) => ({
          type: "type",
          name: option.label,
          value: option.id,
          label: option.label,
          slug: option.id,
        })),
      ],
      phaseOptions: [
        {
          label: i18nService.copy["toolQuickSearch.choose"]?.replace(
            "@filter",
            "fase"
          ),
          value: "",
          type: "",
          name: "",
        },
        ...toolboxSearchData[1].options.map((option: any) => ({
          type: "phase",
          name: option.label,
          value: option.id,
          label: option.label,
          slug: option.id,
        })),
      ],
    };

    ReactDOM.render(
      <BrowserRouter>
        <QueryParamProvider
          ReactRouterRoute={Route}
          stringifyOptions={{
            transformSearchString: transformSearchStringJsonSafe, // allow comma in query string
          }}
        >
          <ToolboxSearch
            toolboxSearchData={toolboxSearchData}
            parentToolId={parentToolId!}
          />
        </QueryParamProvider>
      </BrowserRouter>,
      toolboxSearchContainer
    );
  });
})();
